import { Button, Stack, TextField, Box } from '@mui/material'
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import { getSearchBuyer } from '../reducers/buyerListsReducer';
import swal from 'sweetalert'
import DialogField from './DialogField';


const SearchAddNew = () => {

    const dispatch = useDispatch()

    const store_buyerlists = useSelector((state : RootState) => state.buyer_lists)

    const [searchValue, setSearchValue] = useState("");
    const [dataBuyer, setDataBuyer] = useState<any>([]);
    const [open, setOpen] = useState(false);

    const onClickSearch = (e : any) => {
        e.preventDefault()
        dispatch(getSearchBuyer(searchValue))
    }

    useEffect(() => {
        if(store_buyerlists.loaded_search) {
            if(store_buyerlists.search_buyer !== null) {
                setOpen(true);
                setDataBuyer(store_buyerlists.search_buyer)
            } else {
                swal('Not Found!', "Company Not Found! Please contact your Buyer Admin to get the correct company code.", 'error')
            }
        }
        // eslint-disable-next-line
    }, [store_buyerlists.loaded_search]);


    return (
        <div>
            <form onSubmit={onClickSearch}>
                <Stack direction="row" alignItems="center" alignContent="center" pt={3} >
                    <Box pr={2}>Add New Buyer</Box>
                    <Box>
                        <TextField 
                            label="Find by Company Code"
                            size="small"
                            onChange={(e) => setSearchValue(e.target.value)}
                            required
                        />
                    </Box>
                    <Box pl={2}>
                        <Button
                            variant='outlined'
                            type='submit'
                        >{ store_buyerlists.loading_search ? "Loading" : "Search" } </Button>
                    </Box>
                </Stack>
            </form>
            <DialogField 
                open={open}
                dataBuyer={dataBuyer}
                setOpen={setOpen}
                name="Create New Preferred Buyer"
            />
        </div>
    )
}

export default SearchAddNew
